<!-- SIDENAV CONTENT -->
<div class="content simple-scroll">

  <!--<div class="p-24">
      <button mat-raised-button
              class="mat-accent compose-dialog-button w-100-p"
              (click)="composeDialog()"
              aria-label="Compose">
          {{ 'MAIL.COMPOSE'  }}
      </button>
  </div>-->


  <div class="nav m-t-30">

    <!--<div class="nav-subheader">{{ 'MAIL.FOLDERS'  }}</div>-->

    <!--<div class="nav-item" *ngFor="let folder of (folders$ | async)">-->
    <!--<a class="nav-link" matRipple [routerLink]="'/apps/mail-ngrx/' + folder.handle" routerLinkActive="active">-->
    <!--<mat-icon class="nav-link-icon" *ngIf="folder.icon">{{folder.icon}}</mat-icon>-->
    <!--<span>{{folder.title}}</span>-->
    <!--</a>-->
    <!--</div>-->

    <!--<div class="nav-subheader">{{ 'MAIL.FILTERS'  }}</div>-->

    <!--<div class="nav-item" *ngFor="let filter of (filters$ | async)">-->
    <!--<a class="nav-link" matRipple [routerLink]="'/apps/mail-ngrx/filter/' + filter.handle"-->
    <!--routerLinkActive="active">-->
    <!--<mat-icon class="nav-link-icon" [ngClass]="filter.color" *ngIf="filter.icon">{{filter.icon}}</mat-icon>-->
    <!--<span>{{filter.title}}</span>-->
    <!--</a>-->
    <!--</div>-->

    <!--<div class="nav-subheader">{{ 'MAIL.LABELS'  }}</div>-->
    <div class="nav-item" *ngFor="let label of (labels$ | async)" [ngClass]="{'active': label.isClicked}">
      <a class="nav-link flex flex-row justify-start items-center" matRipple [routerLink]="'/mail/' + label.id">

        <mat-icon role="img" aria-hidden="true" *ngIf="label.title == 'Inbox'">inbox</mat-icon>
        <mat-icon role="img" aria-hidden="true" *ngIf="label.title == 'Favorite'">star</mat-icon>
        <i class="far fa-exclamation-square" *ngIf="label.title == 'Important'"></i>
        <mat-icon role="img" aria-hidden="true" *ngIf="label.title == 'Sent'">send</mat-icon>
        <i class="far fa-archive" *ngIf="label.title == 'Archived'"></i>
        <i class="far fa-user-headset" *ngIf="label.title == 'Support'"></i>
        <span>{{label.title}}</span>
      </a>
    </div>

  </div>

</div>
<!-- / SIDENAV CONTENT -->
